import React from "react";
import {Route, Redirect} from "react-router-dom";
import PropTypes from "prop-types";
import {connect} from "react-redux"; 
import cookie from 'react-cookies';

const UserRoute = ({isAuthenticated, component: Component, ...rest}) => (
	<Route {...rest} render = { props => 
		isAuthenticated ? ( <Component {...props} />   ) : ( <Redirect to = "/"/>)
	 } />

);

UserRoute.propTypes = {
	component: PropTypes.func.isRequired,
	isAuthenticated: PropTypes.bool.isRequired
};

function mapStateToProps (state) {
	return {
		// isAuthenticated: !!localStorage.BookAppLogin,
		isAuthenticated: !!state.user.name//token
	}
};

export default connect(mapStateToProps) (UserRoute);
